import type {
  ParcelSelectDispatchProps,
  ParcelSelectStateProps,
} from '~/components/ParcelSelect/ParcelSelect';
import ParcelSelect, { ParcelSelectField } from '~/components/ParcelSelect/ParcelSelect';

export { ParcelSelectStateProps, ParcelSelectDispatchProps, ParcelSelectField };

export default ParcelSelect;
